module.exports = __webpack_public_path__ + "static/media/BARC.b0d48e87.png";